import React, { FC } from "react";
import { Control, Controller, FieldValues } from "react-hook-form";
import clsx from "clsx";
import { IInputProps } from "../types";
import Input from ".";

export interface IProps {
    name: string;
    required?: string;
    placeHolder?: string;
    control?: Control<FieldValues, any>;
    className?: string;
    isDisabled?: boolean;
    value?: string;
    numericOnly?: boolean;
    pattern?: any;
    maskingPattern?: RegExp;
    maxLength?: number;
    autoComplete?: boolean;
    type?: string;
    min?: number;
    max?: number;
}
const InputControl: FC<IProps & React.HTMLAttributes<IInputProps>> = ({ name, type, required = false, placeHolder, control, className, isDisabled, value, pattern, maskingPattern, numericOnly, maxLength, autoComplete, min, max, ...restProps }) => {
    return (
        <Controller
            name={name}
            control={control}
            rules={{
                required,
                pattern: { ...pattern }
            }}

            render={({ field, fieldState }) => {
                let masked = field.value
                if (maskingPattern)
                    masked = (field?.value ?? "").replace(maskingPattern, "*");

                return (
                    <>
                        <Input id={name}
                            type={type}
                            className={clsx("rounded-md border-none bg-gray-100 focus:bg-gray-100 text-gray-700", className)}
                            placeholder={placeHolder}
                            onChange={(e: any) => {
                                if (numericOnly && !/^\d*$/.test(e.target.value)) {
                                    return;
                                }
                                field.onChange(e.target.value);
                                if (restProps.onChange) {
                                    restProps.onChange(e.target.value);
                                }
                            }}
                            onBlur={(e: any) => {
                                if (restProps.onBlur) {
                                    restProps.onBlur(e.target.value);
                                }
                            }}
                            onKeyDown={restProps.onKeyDown}
                            onPaste={restProps.onPaste}
                            name={field.name}
                            value={isDisabled && maskingPattern ? masked : field.value ?? ""}
                            disabled={isDisabled}
                            maxLength={maxLength}
                            autoComplete={autoComplete ?? false ? "on" : "off"}
                            min={min}
                            max={max}
                        />
                        {fieldState.error &&
                            <div className="text-red-900 font-semibold mt-1">
                                {fieldState.error?.message}
                            </div>
                        }
                    </>
                )
            }}
        />
    )
}

export default InputControl;